/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
// Support component names relative to this directory:

import Cookies from 'js-cookie'

import ItemsSearchUrlBuilder from 'Utils/ItemsSearchUrlBuilder'
import { initSentry } from 'Utils/index'
import { setSentryUser } from 'Utils/SentryConfig'

import { AuthenticationInterceptor } from 'Pods/Shared/CookieInterceptor/CookieInterceptor'
import {
  CustomEventTracker,
} from 'Pods/Shared/UserTracker/UserTracker'

window.ItemsSearchUrlBuilder = ItemsSearchUrlBuilder

initSentry(window)

const uuid = Cookies.get('_cgtrader_uuid')
const username = Cookies.get('_cgtrader_utoken')
setSentryUser(uuid, username)

CustomEventTracker()

window.addEventListener('load', () => {
  AuthenticationInterceptor()
})
